import React from 'react';
import { Link } from 'react-router-dom';

import GooglePlayLinkImage from 'assets/google-play.png';
import iOSLinkImage from 'assets/ios.png';

const MobileApps = () => (
	<div className="footer-links">
		<h3>Mobile app</h3>
		<div className="footer-links__mobile-apps">
			<Link to="/mobile#iOSSection" className="footer-links__image-wrapper">
				<img src={iOSLinkImage} alt="loading" />
			</Link>
			<Link to="/mobile#androidSection" className="footer-links__image-wrapper">
				<img src={GooglePlayLinkImage} alt="loading" />
			</Link>
		</div>
	</div>
);

export default MobileApps;
